export default __webpack_public_path__ + "static/peace_hand_benefits-7542596c5bbed4fbe8e88d07b8995073.png";